import React from "react";
import { Descriptions } from "antd";

const money = value => `AED ${Number(value || 0).toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function HandoverFinancialSummary({ financial }) {
  if (!financial) return null;
  return <Descriptions size="small" bordered column={3}>
    <Descriptions.Item label="Invoice">{money(financial.invoice_total)}</Descriptions.Item>
    <Descriptions.Item label="Received">{money(financial.received_amount)}</Descriptions.Item>
    <Descriptions.Item label="Due">{money(financial.due_amount)}</Descriptions.Item>
  </Descriptions>;
}
